import React, { useState } from 'react';

export default function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="faq-item"
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
    >
      <button
        className="faq-q"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        itemProp="name"
      >
        {q}
        <span className={`faq-icon${open ? ' open' : ''}`}>+</span>
      </button>
      <div
        className={`faq-a${open ? ' open' : ''}`}
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <span itemProp="text">{a}</span>
      </div>
    </div>
  );
}
